import { ref, Ref } from 'vue';
import { Annotation, Counterpoint } from '../types/annotation.types';
import { EventBus } from '@/assets/js/event-bus';

export function useAnnotationHover(
  annotation: Ref<Annotation>,
  parentCounterpoint: Ref<Counterpoint>,
  annotationActive: Ref<string>,
  setSelectedAnnotation: (params: {
    counterpoint: Counterpoint | Record<string, never>;
    annotation: Annotation | Record<string, never>;
  }) => void,
  annotationFocusIn: (annotation: Annotation) => void,
  annotationFocusOut: () => void,
  getRefByAnnotationsIds: (annotation: Annotation) => string[]
) {
  const hover = ref<boolean>(false);
  const topBarHover = ref<boolean>(false);
  const displayNone = ref<boolean>(true);
  const addEllipsis = ref<boolean>(true);
  const isFocused = ref<boolean>(false);

  const hoverIn = (
    event: Event,
    useInstruction: boolean,
    activeFocus: Ref<boolean>,
    previousText: Ref<string>
  ) => {
    EventBus.emit('annotation.hover.cancel-geometry-update');
    addEllipsis.value = false;
    displayNone.value = false;
    hover.value = true;
    topBarHover.value = true;

    setSelectedAnnotation({
      counterpoint: parentCounterpoint.value,
      annotation: annotation.value,
    });

    const refAnnotations = getRefByAnnotationsIds(annotation.value);
    EventBus.emit('annotation.active', refAnnotations[refAnnotations.length - 1]);
    annotationFocusIn(annotation.value);
    activeFocus.value = true;
    previousText.value = useInstruction
      ? annotation.value.instruction || ''
      : annotation.value.comment;

    return { event, annotation: annotation.value };
  };

  const hoverOut = () => {
    addEllipsis.value = true;

    if (annotation.value._id !== annotationActive.value) {
      const bubbleMenu = document.getElementById('annotations-menu');
      if (!bubbleMenu || !bubbleMenu.matches(':hover')) {
        setSelectedAnnotation({
          counterpoint: {},
          annotation: {},
        });
        displayNone.value = true;
        hover.value = false;
        topBarHover.value = false;
        annotationFocusOut();
        EventBus.emit('annotation.active', '');
        EventBus.emit('annotation.hover.schedule-geometry-update');
      }
    }
  };

  const doHoverInAnnotation = () => {
    hover.value = true;
  };

  const doHoverOutAnnotation = () => {
    if (annotation.value._id !== annotationActive.value) {
      hover.value = false;
    }
  };

  return {
    hover,
    topBarHover,
    displayNone,
    addEllipsis,
    isFocused,
    hoverIn,
    hoverOut,
    doHoverInAnnotation,
    doHoverOutAnnotation,
  };
}
